import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, CreatorAssetOS } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-2380" data-mp="2dhgoku5fng5v" />
      <Logos data-id="element-2381" data-mp="2dhyuyjlt7ari" />
      <Problem data-id="element-2382" data-mp="2dii358lnqksc" />
      <CastingCalls data-id="element-2383" data-mp="2dj9wsdvp28fz" />
      <RosterDatabase data-id="element-2384" data-mp="2dfdrjq5v4mrn" />
      <Audiences data-id="element-2385" data-mp="3kvk44fox8t3v" />
      <ProductWorkflow data-id="element-2386" data-mp="3kw1yf6s0wx95" />
      <Moat data-id="element-2387" data-mp="3kuqv182hprik" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-2388" data-mp="3kv0pb7ukiku2" />
      <InfluencerHub data-id="element-2389" data-mp="3oyq9ll47mg9a" />
      <CapterraReviews data-id="element-2390" data-mp="30wjaok4gik28" />
      <CreatorAssetOS data-id="element-2391" data-mp="30vqe2bz7paxt" />
      <CTA data-id="element-2392" data-mp="30w9luzv5eiy4" />
      <Newsletter data-id="element-2393" data-mp="30w02vw8itc1x" />
    </>;
};